import ReactHookFormGenerator from 'Global/ReactHookFormGenerator/ReactHookFormGenerator';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { GetCurrentDateInJalai } from 'utils/GetCurrentDateInJalai';
import useUploaderFormDataArray from '../hooks/useUploaderFormDataArray';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import {
  Button,
  LinearProgress,
  Stack,
} from '@mui/material';
import FileSelectorBtn from 'Global/Components/CommonComponents/UploaderWithBackdrop/components/FileSelectorBtn';
import { Base64Selector } from 'utils/Base64Selector';
import SubmitButton from 'Global/Components/UnEditableComponents/SubmitButton/SubmitButton';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useNavigate } from 'react-router-dom';
import { add_reception } from 'Routes/Protected/FreezeContracts/Functions/add_reception';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
 
const UploaderForm = ({ details }) => {
  
  const [fileSelectorError,setFileSelectorError] = useState(false);

  const [loading, setEnableLoading] = useState();

  const navigate = useNavigate();

  const [base64, setBase64] = useState();

  const fileInputRef = useRef(null);

  //labels    =============================================
  const price = FindLangKey('freeze-contracts-label-price');
  const tracing_id = FindLangKey(
    'general-public-tracking-code'
  );
  const desc = FindLangKey(
    'general-public-select-description'
  );

  const saveBtn_label = FindLangKey(
    'general-public-btn-save'
  );

  const cancelBtn_label = FindLangKey(
    'general-public-btn-cancel'
  );

  const noFile_selected = FindLangKey(
    'add-new-alert-no-items-selected'
  );

  // console.log('details--->', details);

  //form data elements =============================================

  const DataArray = useUploaderFormDataArray(
    price,
    tracing_id,
    details,
    base64
  );

  const { control, formState, handleSubmit } = useForm({
    defaultValues: {
      fileName: '',
      fileDate: GetCurrentDateInJalai(),
      fileDescription: '',
      fileBase64: '',
    },
  });


  useEffect(()=>{
if(base64){
  setFileSelectorError(false)
}
  },[base64])

  return (
    <React.Fragment>
      <form
        onSubmit={handleSubmit((data) => {
          if (!base64) {
            SwalAlert('warning', noFile_selected, false);
            setFileSelectorError(true);
            return;
          }
          add_reception(
            {
              ...data,
              idTestimontial: details?.IdTestimontial,
              ...base64,
            },
            setEnableLoading,
            navigate
          );
        })}
      >
        <Stack gap=".5em" mt="1em">
 
         
          <FileSelectorBtn
            select={desc}
            fileInputRef={fileInputRef}
            fileSelectorError={fileSelectorError}
          />
          <ReactHookFormGenerator
            control={control}
            formState={formState}
            DataArray={DataArray}
          />
          <Stack direction="row-reverse" gap=".5em">
            <SubmitButton label={saveBtn_label} />
            <Button
              fullWidth
              variant="contained"
              sx={{
                maxHeight: '40px',
                color: `${themeColors.ColorPrimary} !important`,
              }}
              onClick={() => {
                sessionStorage.removeItem('temp_ureceit');
                navigate(-1);
              }}
            >
              {cancelBtn_label}
            </Button>
          </Stack>

          {loading ? <LinearProgress /> : <></>}
        </Stack>
        <input
          onChange={(event) =>
            Base64Selector(event, setBase64)
          }
          type="file"
          accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, application/pdf, image/*"
          hidden
          ref={fileInputRef}
        />
      </form>
    </React.Fragment>
  );
};

export default UploaderForm;
